export default "__VITE_ASSET__DT3_MyQV__"